<div class="flex flex-col gap-8 p-4">
    <div class="">
        <h2>Alertas: Outline, conforme o Figma</h2>
        <div class="mb-2" *ngFor="let type of figmaTypes">
            <fuse-alert [appearance]="'outline'" [type]="type" [dismissible]="true" [showIcon]="true">
                <mat-icon fuseAlertIcon [svgIcon]="'exclamation-circle'"></mat-icon>
                <span fuseAlertTitle>Title</span>
                <span fuseAlertMessage> This is a {{ type }} alert with outline appearance.</span>
            </fuse-alert>
        </div>

        <div class="mb-2" *ngFor="let type of otherTypes">
            <fuse-alert [appearance]="'outline'" [type]="type" [dismissible]="true" [showIcon]="true">
                <mat-icon fuseAlertIcon [svgIcon]="'exclamation-circle'"></mat-icon>
                <span fuseAlertTitle>Title</span>
                <span fuseAlertMessage> This is a {{ type }} alert with outline appearance.</span>
            </fuse-alert>
        </div>
    </div>

    <div>
        <h2>Alertas: Outros exemplos de outline</h2>
        <fuse-alert class="mb-4" [appearance]="'outline'" [type]="'primary'" [dismissible]="true" [showIcon]="true">
            <div fuseAlertIcon>
                <mat-icon [svgIcon]="'exclamation-circle'"></mat-icon>
            </div>
            <span fuseAlertTitle>Title</span>
            <span fuseAlertMessage> Short text </span>
        </fuse-alert>
        <fuse-alert class="mb-4" [appearance]="'outline'" [type]="'warn'" [dismissible]="false" [showIcon]="true">
            <mat-icon fuseAlertIcon [svgIcon]="'exclamation-circle'"></mat-icon>
            <span fuseAlertTitle>Title</span>
            <span fuseAlertMessage>
                This is a warn alert with outline appearance. With a long text, and it is not dismissible. So it has no
                close button.
                <br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit.
            </span>
        </fuse-alert>
    </div>

    <div>
        <h2>Outros alertas</h2>
        <div *ngFor="let appearance of appearances" class="mb-4">
            <div *ngFor="let type of allTypes">
                <fuse-alert [appearance]="appearance" [type]="type" [dismissible]="true" [showIcon]="true">
                    <mat-icon fuseAlertIcon [svgIcon]="'exclamation-circle'"></mat-icon>
                    <span fuseAlertTitle>Title</span>
                    <span fuseAlertMessage> This is a {{ type }} alert with {{ appearance }} appearance.</span>
                </fuse-alert>
            </div>
        </div>
    </div>
</div>
